import Vue from "vue";
import ConfirmComponent from "@erp/shared/components/ui/Unclassified/ConfirmComponent.vue";
import vuetify from "@erp/shared/plugins/vuetify";
const ConfirmConstructor = Vue.extend(ConfirmComponent);
function toMessageStr(message) {
    if (typeof message !== "object" || message === null) {
        return String(message);
    }
    const obj = message;
    if (typeof obj.message === "string")
        return obj.message;
    if (typeof obj.msg === "string")
        return obj.msg;
    return JSON.stringify(message);
}
/**
 * 확인 대화상자를 표시하고, 확인 시 페이지를 새로고침한다.
 */
export function showResult(message, title = "확인", useInput = false, confirmText = "확인", cancelText = "취소") {
    return new Promise((resolve) => {
        const messageStr = toMessageStr(message);
        const confirmInstance = new ConfirmConstructor({
            vuetify,
            propsData: { message: messageStr, title, useInput, confirmText, cancelText },
        });
        confirmInstance.$mount();
        document.body.appendChild(confirmInstance.$el);
        confirmInstance.show();
        confirmInstance.$on("close", (result) => {
            resolve(result);
            if (result) {
                window.location.reload();
            }
            document.body.removeChild(confirmInstance.$el);
            confirmInstance.$destroy();
        });
    });
}
